import {
  baseApi,
} from '@shared/api';
import {
  mapTournament,
} from '../lib';
import type {
  TournamentWithRanking,
  TournamentWIthCategories,
  TournamentsWithRanking,
} from '../model';

export type GetTournamentWithRankingParams = {
  partyId?: string;
  rankingEnd?: number;
  tournamentId: number;
};

export const tournamentsApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTournamentsWithCategories: build.query<TournamentWIthCategories, { partyId: string }>({
      query: (args) => ({
        url: '/api/ips/get-tournaments-with-categories',
        params: args,
      }),
      extraOptions: { showLoader: false, auth: true },
      transformResponse: (response: any) => ({
        ...response,
        tournamentList: response?.tournamentList?.map(mapTournament),
        publicTournamentList: response?.publicTournamentList?.map(mapTournament),
      }),
    }),
    getTournamentWithRanking: build.query<TournamentWithRanking, GetTournamentWithRankingParams>({
      query: (args) => ({
        url: '/api/ips/get-tournament-with-ranking',
        params: args,
      }),
      extraOptions: { showLoader: false, auth: false },
    }),
    getTournamentsWithRanking: build.query<TournamentsWithRanking, { partyId: string }>({
      query: (args) => ({
        url: '/api/ips/get-tournaments-with-ranking',
        params: args,
      }),
      extraOptions: { showLoader: false, auth: true },
      transformResponse: (response: any) => ({
        ...response,
        activeTournaments: response?.activeTournaments?.map(mapTournament),
        pendingTournaments: response?.pendingTournaments?.map(mapTournament),
        privateTournamentList: response?.privateTournamentList?.map(mapTournament),
      }),
    }),
  }),
});

export const {
  useGetTournamentsWithCategoriesQuery,
  useLazyGetTournamentsWithCategoriesQuery,
  useGetTournamentWithRankingQuery,
  useLazyGetTournamentWithRankingQuery,
  useGetTournamentsWithRankingQuery,
  useLazyGetTournamentsWithRankingQuery
} = tournamentsApiSlice;
